export enum ReclamationTypes {
    ADMINISTRATIVE = 'administrative',
    TECHNICAL = 'technical',
}

export enum ReclamationReason {
    //administrative
    BILL = 'administratif_facture',
    RESIL_FACTU = 'administratif_resil_factu',
    ERREUR_RESIL = 'administratif_erreur_resil',
    DOC_DUPLICATA = 'administratif_doc_duplicata',
    DOCUMENT_REQUEST = 'administratif_documents',
    PAIEMENT = 'administratif_paiement',
    DOUBLE_FACTU = 'administratif_double_factu',
    ERROR_FACTU = 'administratif_error_factu',
    DEMANDE_REMBOURSEMENT = 'administratif_demande_remboursement',
    DEMANDE_PENALITE = 'administratif_demande_penalite',
    COMMERCIAL = 'administratif_commercial',
    LIVRAISON = 'administratif_livraison',
    OTHER = 'administratif_autre',
    CHANGE_RIB = 'administratif_change_rib',
    CHANGE_JURIDIQUE = 'administratif_change_juridique',
    CONTEST_ABO = 'administratif_contest',
    FUSION_ENTREPRISE = 'administratif_fusion_entreprise',
    PASSAGE_PRELEV = 'administratif_passage_prelev',
    PASSAGE_SEPA = 'administratif_passage_sepa',

    //technical
    DEGRADATION_OF_SERVICE = 'technique_degradation_service',
    SERVICE_OUTAGE = 'technique_coupure_service',
    REQUEST_FOR_INFORMATION = 'technique_demande_information',
    REQUEST_FOR_CONFIGURATION = 'technique_config_router',
}
